import type { PlacedThought } from "../types/adventure";
import { REQUIRED_HELPFUL } from "../lib/game-state";

interface HelpfulDashboardProps {
  selectedIds: string[];
  thoughts: PlacedThought[];
  systemMap: Record<string, { label: string; icon: string }>;
  focusMode: boolean;
}

export function HelpfulDashboard({
  selectedIds,
  thoughts,
  systemMap,
  focusMode,
}: HelpfulDashboardProps) {
  const slots = Array.from({ length: REQUIRED_HELPFUL }, (_, i) => {
    const id = selectedIds[i];
    const thought = id ? thoughts.find((t) => t.thoughtId === id) : null;
    return { index: i, thought };
  });

  return (
    <div
      className={`act-helpful-dashboard${focusMode ? " act-helpful-dashboard--active" : ""}`}
      role="region"
      aria-label="Dashboard met helpende gedachten"
    >
      <p className="act-helpful-dashboard__label">
        {focusMode
          ? "Jouw helpende gedachten"
          : `Kies helpende gedachten (${selectedIds.length}/${REQUIRED_HELPFUL})`}
      </p>
      <div className="act-helpful-dashboard__slots">
        {slots.map(({ index, thought }) => {
          const sys = thought ? systemMap[thought.system] : null;
          return (
            <div
              key={index}
              className={
                thought
                  ? "act-helpful-dashboard__slot act-helpful-dashboard__slot--filled"
                  : "act-helpful-dashboard__slot"
              }
            >
              {thought ? (
                <>
                  <span className="act-helpful-dashboard__icon" aria-hidden>
                    {sys?.icon ?? "💭"}
                  </span>
                  <span className="act-helpful-dashboard__text">{thought.text}</span>
                </>
              ) : (
                <span className="act-helpful-dashboard__empty" aria-hidden>
                  +
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
